import MarkerClusterer from './markerclusterer'

if (document.querySelector('#map-container')){

    const loadedGoogleMapsAPI = new Promise((resolve,reject) => {
        if (document.querySelector('#gmaps-api')) return;

        window['GoogleMapsInit'] = resolve;

        let scriptApi = document.createElement('script');
        scriptApi.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD0ZpQb31MFM7HnzWu0jeWVURr04eZdQRs&callback=GoogleMapsInit`;
        scriptApi.async = true;
        scriptApi.id = 'gmaps-api';

        document.body.appendChild(scriptApi);
    });

    function CustomMarker(latlng, map, info) {
        function Marker(latlng, map, info) {
            this.latlng = latlng;
            this.info = info;
            this.setMap(map);
        }

        Marker.prototype = new google.maps.OverlayView();

        Marker.prototype.draw = function() {

            const self = this;
            let div = this.div;

            if (!div) {
                div = this.div = document.createElement('div');
                div.className = 'map-icon';
                div.style.position = 'absolute';

                const panes = this.getPanes();
                panes.overlayImage.appendChild(div);

                if (this.info) {
                    google.maps.event.addDomListener(this.div, 'click', () => {
                        this.info.open(this.map, this);
                    });

                    //google.maps.event.addListener(this.map, 'click', () => {
                    //    this.info.close();
                    //});
                }


            }

            const point = this.getProjection().fromLatLngToDivPixel(this.latlng);

            if (point) {
                div.style.left = (point.x - 10) + 'px';
                div.style.top = (point.y - 10) + 'px';
            }
        };

        Marker.prototype.remove = function() {
            if (this.div) {
                google.maps.event.clearInstanceListeners(this.div);
                this.div.parentNode.removeChild(this.div);
                this.div = null;
            }
        };

        Marker.prototype.getPosition = function() {
            return this.latlng;
        };

        return new Marker(latlng, map, info);
    }

    function initMap(){
        /*
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
                };

                map.setCenter(pos);

            }, function() {
                handleLocationError(true, map.getCenter());
            });
        } else {
            handleLocationError(false, map.getCenter());
        }

        function handleLocationError(browserHasGeolocation, pos) {
            if(browserHasGeolocation){
                alert('Error: The Geolocation service failed.');
            }else{
                alert('Error: Your browser doesn\'t support geolocation.');
            }
          }

        */

        const MapCenter = new google.maps.LatLng(coordinates.latitude, coordinates.longitude);

        const map = new google.maps.Map(document.getElementById('map'), {
            zoom: 13,
            center: MapCenter,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f8f2ed"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#ffc88f"}]}]
        });

        let markers = [];

        restaurants.forEach(data => {

            const latLng = new google.maps.LatLng(
                data.latitude,
                data.longitude
            );


            const info = new google.maps.InfoWindow({
                content: data.photo_title,
                maxWidth: 350,
                pixelOffset: new google.maps.Size(0, -10)
            });


            const marker = CustomMarker(
                latLng,
                map,
                info
            );

            markers.push(marker);
        });


        const options = {
            imagePath: "img/m",
            styles:[{
                url: '/img/m1.svg',
                width: 41,
                height: 37,
                textColor: '#fff'
            }]

        };
        const markerCluster = new MarkerClusterer(map, markers, options);
    }

    loadedGoogleMapsAPI.then(()=>{
        initMap()
    });

}







// WEBPACK FOOTER //
// ./resources/assets/js/gmap.js